"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ostra": {
    "6bd1d928": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "skipSearch": false
    }],
    "molino-collina": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "915c6009": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "391c2b4f": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d190b454": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "skipSearch": false
    }],
    "sant-ubaldo-pozzuolo": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7a02a7e2": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-apparve": [{
      "hkey": "514a0581",
      "slug": "ostra",
      "name": "Ostra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;